<h1 matDialogTitle>
  {{ "edit-collection.practice-interval-item-dialog.title" | translate }}
</h1>

<div matDialogContent>
  @for (item of existingCollectionItems; track $index) {
    <div>
      @if ($index > 0) {
        <mat-divider></mat-divider>
      }
      <div
        class="flex flex-col items-start justify-between md:flex-row md:items-center"
      >
        <span class="m-4 max-w-96 truncate whitespace-nowrap">
          {{ item.musicPiece.musicPiece.nameOfPiece }}
        </span>

        <div class="join mb-4 md:mb-0">
          <button
            class="btn join-item btn-sm"
            [class.btn-primary]="!item.collectionItem.practiceInterval"
            (click)="updatePracticeInterval(item, 0)"
          >
            {{
              "edit-collection.practice-interval-item-dialog.never" | translate
            }}
          </button>
          <button
            class="btn join-item btn-sm"
            [class.btn-primary]="item.collectionItem.practiceInterval == 1"
            (click)="updatePracticeInterval(item, 1)"
          >
            {{
              "edit-collection.practice-interval-item-dialog.daily" | translate
            }}
          </button>
          <button
            class="btn join-item btn-sm"
            [class.btn-primary]="item.collectionItem.practiceInterval == 7"
            (click)="updatePracticeInterval(item, 7)"
          >
            {{
              "edit-collection.practice-interval-item-dialog.weekly" | translate
            }}
          </button>
          <button
            class="btn join-item btn-sm"
            [class.btn-primary]="item.collectionItem.practiceInterval == 30"
            (click)="updatePracticeInterval(item, 30)"
          >
            {{
              "edit-collection.practice-interval-item-dialog.monthly"
                | translate
            }}
          </button>
        </div>
      </div>
    </div>
  }
</div>

<div matDialogActions fxLayout="row" fxLayoutAlign="end">
  <button mat-button [mat-dialog-close]>
    {{ "common.cancel" | translate }}
  </button>
  <button mat-button (click)="update()" [disabled]="!isDirty" color="primary">
    {{ "common.save" | translate }}
  </button>
</div>
